module.exports = __webpack_public_path__ + "components/rewards-header/static/background-b6e72e1e463432cdb053d87c4ff3f889.webp";